module.exports = __webpack_public_path__ + "static/media/29DUNON8.4621bcd1.jpg";